<template>
    <div class="about">
        <div class="banner">
            <div class="banner__title">
                易猎云（海南）科技有限公司
            </div>
            <p>国内领先的RPO企业招聘数字化解决方案提供商</p>
        </div>
        <div class="introduction">
            <div class="intr_box">
                <p class="intr__title">公司介绍</p>
                <p class="intr__text">
                    易猎云，中国领先的RPO企业招聘管理系统综合解决方案供应商，以“招聘数字化”为使命，将先进的数字化管理理念融入招聘管理系统，做到招聘流程可视化、数字化、智能化，通过技术和服务赋能RPO招聘企业。
                </p>
                <p class="intr__text" style="margin-top:.3rem">
                    易猎云一直奉行“技术驱动，产品领先”的经营理念，从成立之初就聚集国内相关领域的顶尖人才，如智联、北森、BOSS直聘、BAT等知名企业，通过长期的技术投入和产品迭代，积累了完整成熟的产品矩阵，包括易猎招聘管理系统、易享员工服务系统、易猎职享等产品，产品之间实现了相互打通，全流程业务无缝衔接。迄今为止，累计服务客户包括位来小猎、陕西易通、熊猫云聘、点米科技、勇晖集团等500余家客户。
                </p>
                <p class="intr__text" style="margin-top:.3rem">
                     未来，易猎云将继续深耕RPO批量招聘及HRO领域，将先进的技术与在批量基础岗位招聘、小微人力资源企业数字化建设等方面积累的业务实践经验结合起来，打造国内RPO招聘领域的第一品牌，助力更多国内外人力资源企业实现数字化升级和改造。
                </p>
            </div>
        </div>
        <!-- <div class="trial">
            <div class="tr_title">
                <div class="tr_left">
                    <img src="https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/icon_customer_service%402x.png"/>
                </div>
                <h2>即刻开启数字化招聘人效提升之旅</h2>
            </div>   
            <div class="tr_btn" @click="rogoprice">免费体验</div>
        </div> -->
    </div>
</template>
<script>
export default {
    name:'about',
    data(){
        return{
            routeData:{}
        }
    },
    mounted(){
        if (Object.keys(this.$route.query).length) {
            this.routeData = this.$route.query
        }
        const {u=''} = this.routeData;
        if(!u){
            console.log("WWWW");
            zhuge.track("官网关于我们", {
                渠道: '移动',
                utm类型: "自然流量",
            });
        }else{
             zhuge.track("官网关于我们", {
                渠道: '移动',
                utm类型: "驱动流量",
            });
        }

    },
    metaInfo: {
      title: '关于易猎云-更适合RPO的易猎云招聘管理系统',
      meta: [
        {
          name: 'keywords',
          content: '易猎云，易猎云海南，易猎云招聘，招聘管理系统，RPO批量招聘'
        },
        {
          name: 'description',
          content: '易猎云招聘管理系统，RPO公司批量招聘数字化首选的招聘系统'
        }
      ]
    },
    methods:{
        //免费体验
        rogoprice(){
             this.$router.push({path:'/apply',query:this.routeData});
        },
    }
}
</script>
<style lang="less" scoped>
.about{
     margin-top: .43rem;
    .banner{
        position: relative;
        width: 100%;
        height: 1.65rem;
        background-image: url('https://img.yilieyun.com/oss/ylyh5officialWebimagese/banner_about me@2x.png');
        background-repeat: no-repeat;
        background-size: 100% 1.65rem;
        .banner__title{
            position: absolute;
            width: 2.07rem;
            height: .32rem;
            background: #1990FF;
            font-size: .14rem;
            color: #ffffff;
            text-align: center;
            line-height: .32rem;
            left: .28rem;
            top: .38rem;
        }
        p{
            position: absolute;
          
            height: .66rem;
            font-size: .14rem;
            color: #1D2754;
            line-height: .22rem;
            left: .28rem;
            top: .83rem;

        }
    }
    .introduction{
        width: 100%;
        height: 7.55rem;
        padding-top: .24rem;
        background: #E7F2FF;
        .intr_box{
            width: 3.38rem;
            margin: 0 auto;
            background: #FFFFFF;
            border-radius: .1rem;
            padding-bottom: .2rem;
            .intr__title{
                font-size: .14rem;
                color: #1D2754;
                line-height: .51rem;
                text-align: center;
                font-weight: 500;
            }
            .intr__text{
                font-size: .14rem;
                color: #1D2754;
                line-height: .3rem;
                padding-left: .17rem;
                padding-right: .17rem;
                text-indent:2em;
                text-align: justify;
            }
        }
    }
    .trial{
            width: 100%;
            height: 1.14rem;
            background-image: url('https://yilie.oss-cn-beijing.aliyuncs.com/oss/ylyh5officialWebimagese/v2/bg_0133%402x.png');
            background-repeat: no-repeat;
            background-size: 105% 1.57rem;
            background-position: -.1rem;
            padding-top: .32rem;
            .tr_title{
                width: 73%;
                margin: 0 auto;
                display: flex;
                .tr_left{
                    position: relative;
                    width: .45rem;
                    img{
                        position: absolute;
                    }
                }
                h2{
                    flex: 1;
                    font-size: .14rem;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: .43rem;
                    text-align: left;
                    margin-left: .1rem;
                    margin-top: 0 !important;
                }
            }
          
            .tr_btn{
                width: .81rem;
                height: .29rem;
                border-radius: 3px;
                background: #FFFFFF;
                font-size: .14rem;
                color: #215FFF;
                line-height: .29rem;
                text-align: center;
                margin: 0 auto;
                margin-top: .17rem;
            }
        }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/about/index.vue